import { FlexContainer, Layout } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { DESKTOP_EXTRA_SMALL_WIDTH } from 'Styles/variables/sizes';

export const TextContainer = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    align-items: flex-start;
  }
`;

export const SpinnerContainer = styled(FlexContainer)`
  height: 100%;
`;

export const TitleContainer = styled(FlexContainer)`
  @media screen and (min-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: none;
  }
`;

export const Container = styled(Layout.Wrap)`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    border: none;
  }
`;
